// Tab-scoped access session. Never store refresh tokens or send it to the host
// page. A restored session is only a candidate until the API validates it.
const SESSION_KEY = 'groove-affiliate-session';
let embeddedUser = null;
let sessionVersion = 0;
export function getEmbeddedUser() { return embeddedUser; }
export function getEmbeddedSessionVersion() { return sessionVersion; }
export function readEmbeddedSession() {
  try {
    const saved = JSON.parse(window.sessionStorage.getItem(SESSION_KEY));
    if (saved && saved.user && saved.user.id && typeof saved.user.token === 'string' &&
        saved.savedAt > Date.now() - 8 * 60 * 60 * 1000) return saved.user;
  } catch (_) { /* Storage can be blocked in cross-site frames. */ }
  return null;
}
export function setEmbeddedUser(user) {
  sessionVersion++;
  embeddedUser = user;
  try {
    const { id, name, first_name, last_name, email, token, auth_keycloak } = user;
    window.sessionStorage.setItem(SESSION_KEY, JSON.stringify({
      savedAt: Date.now(), user: { id, name, first_name, last_name, email, token, auth_keycloak }
    }));
  } catch (_) { /* The current in-memory session still works. */ }
}
export function clearEmbeddedUser() {
  sessionVersion++;
  embeddedUser = null;
  try { window.sessionStorage.removeItem(SESSION_KEY); } catch (_) { /* No storage. */ }
}
